import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class ImageSensorsAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normMp = 25;
		this.normPxs = 3;
		this.normFps = 20;
		this.normOf = 5;

		this.rankMp = 0;
		this.rankPxs = 0;
		this.rankFps = 0;
		this.rankOf = 0;

		this.weightMp = 0.1;
		this.weightPxs = 0.15;
		this.weightFps = 0.1;
		this.weightOf = 0.15;

		this.rMp = 0;
		this.rPxs = 0;
		this.rFps = 0;
		this.rOf = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log(
				'partNumber,part_Mp,rMp,rankMp,part_Pxs,rPxs,rankPxs,part_Fps,rFps,rankFps,part_Of,rOf,rankOf,feRank'
			);
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);
		// ---------------------------------------------Megapixels (MP)---------------------------------------------

		[this.rankMp, this.rMp] = this.calculateRankDualSliderGTE(CIDS.MEGAPIXELS, product, this.normMp);

		// ---------------------------------------------Pixel Size (μm)---------------------------------------------

		[this.rankPxs, this.rPxs] = this.calculateRankDualSliderGTE(CIDS.PIXEL_SIZE, product, this.normPxs);

		// ---------------------------------------------Frame Rate (fps)---------------------------------------------

		[this.rankFps, this.rFps] = this.calculateRankSingleSliderGTE(CIDS.FRAME_RATE, product, this.normFps);

		// ---------------------------------------------Optical Format (inch)---------------------------------------------

		[this.rankOf, this.rOf] = this.calculateRankDualSliderGTE(CIDS.OPTICAL_FORMAT_NUMBER, product, this.normOf);

		// -------------------------------------------------------------------------------------------

		let feRank =
			this.weightMp * this.rankMp +
			this.weightPxs * this.rankPxs +
			this.weightFps * this.rankFps +
			this.weightOf * this.rankOf;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank =
			(1 - this.weightMp - this.weightPxs - this.weightFps - this.weightOf) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
